export default __webpack_public_path__ + "static/media/right_dedication.47a2ebac.svg";